module.exports = __webpack_public_path__ + "static/posiflex-7bc1005a6174f37c154e434e9f39d913.png";